setInterval(function() {
  const el = document.getElementById('catInfoPrice');
  if (el && el.dataset.lock && el.textContent !== el.dataset.lock) {
    el.textContent = el.dataset.lock;
    el.style.visibility = 'visible';
  }
}, 50);


/* ═══════════════════════════════════════════════════════════════
   THE PHANTASY CO. — theme.js  v3.0
═══════════════════════════════════════════════════════════════ */
/* ── Cart redirect: skip entry + open bag ── */
if (sessionStorage.getItem('openBagPanel') === '1') {
  document.addEventListener('DOMContentLoaded', function () {
    document.body.classList.add('skip-entry');

    sessionStorage.removeItem('openBagPanel');

    var attempts = 0;
    var interval = setInterval(function () {
      attempts++;
      var entryScreen   = document.getElementById('entryScreen');
      var heroMenu      = document.getElementById('heroMenu');
      var heroLogoBlock = document.getElementById('heroLogoBlock');
      var bagBtn        = document.getElementById('bagBtn');

      if (bagBtn && typeof gsap !== 'undefined') {
        clearInterval(interval);
        if (entryScreen) { entryScreen.style.display = 'none'; }
        if (heroMenu)      gsap.to(heroMenu,      { opacity: 1, duration: 0.55, ease: 'power2.out' });
        if (heroLogoBlock) gsap.fromTo(heroLogoBlock, { opacity: 0, y: -14 }, { opacity: 1, y: 0, duration: 0.6, ease: 'expo.out' });
        setTimeout(function () { bagBtn.click(); }, 400);
      }

      if (attempts > 40) clearInterval(interval); // give up after 4 seconds
    }, 100);
  });
}


(function () {
  'use strict';

  function onGsapReady(fn) {
    if (window.gsap) return fn();
    const t = setInterval(() => { if (window.gsap) { clearInterval(t); fn(); } }, 30);
  }
  onGsapReady(boot);

  function boot() {
    const PH       = window.PHANTASY || {};
    const PRODUCTS = PH.products || [];
    const CAT_MAP  = PH.catMap   || {};
    const ROUTES   = PH.routes   || {
      cartAdd:    '/cart/add.js',
      cartChange: '/cart/change.js',
      cartGet:    '/cart.js',
      checkout:   '/checkout',
      search:     '/search/suggest.json',
    };
    const _S = PH.strings || {};
    const STR = {
      catAtb:    _S.catAtb    || 'Add to Bag',
      prodAtb:   _S.prodAtb   || 'Add to Bag',
      added:     _S.added     || 'Added ✓',
      inStock:   _S.inStock   || 'In Stock',
      soldOut:   _S.soldOut   || 'Sold Out',
      noResults: _S.noResults || 'No results found',
    };
    const $  = id  => document.getElementById(id);
    const $$ = sel => Array.from(document.querySelectorAll(sel));
    const D = {
      nav:            $('nav'),
      navLogo:        $('navLogo'),
      navCatBack:     $('navCatBack'),
      heroMenu:       $('heroMenu'),
      heroLogoBlock:  $('heroLogoBlock'),
      heroNav:        $('heroNav'),
      catOverlay:     $('catOverlay'),
      catTitle:       $('catTitle'),
      catGallery:     $('catGallery'),
      catTrack:       $('catTrack'),
      catInfo:        $('catInfo'),
      catInfoCounter: $('catInfoCounter'),
      catInfoName:    $('catInfoName'),
      catInfoBrand:   $('catInfoBrand'),
      catInfoPrice:   $('catInfoPrice'),
      catInfoAtb:     $('catInfoAtb'),
      catInfoDesc:    $('catInfoDesc'),
      catScrollHint:  $('catScrollHint'),
      contactOverlay: $('contactOverlay'),
      prodOverlay:    $('prodOverlay'),
      bagOverlay:     $('bagOverlay'),
      bagPanel:       $('bagPanel'),
      bagBody:        $('bagBody'),
      bagEmpty:       $('bagEmpty'),
      bagSubtotalRow: $('bagSubtotalRow'),
      bagSubtotalVal: $('bagSubtotalVal'),
      bagCount:       $('bagCount'),
      bagBtn:         $('bagBtn'),
      bagClose:       $('bagClose'),
      bagContinue:    $('bagContinue'),
      bagCheckout:    $('bagCheckout'),
      searchOverlay:  $('searchOverlay'),
      searchInput:    $('searchInput'),
      searchResults:  $('searchResults'),
      searchBtn:      $('searchBtn'),
      searchClose:    $('searchClose'),
      entryScreen:    $('entryScreen'),
      entryBtn:       $('entryBtn'),
      entryReceipt:   $('entryReceiptWrap'),
      mobileNav:      $('mobileNav'),
      hamburgerBtn:   $('hamburgerBtn'),
      mobileNavClose: $('mobileNavClose'),
      currencyWrap:   $('currencyWrap'),
      currencyBtn:    $('currencyBtn'),
      currencyLabel:  $('currencyLabel'),
      currencyDrop:   $('currencyDrop'),
    };
    refreshCart();
    setTimeout(refreshCart, 300);

    const S = { HERO: 'hero', CAT: 'category', CONTACT: 'contact' };
    let appState      = S.HERO;
    let activeCat     = null;
    let transitioning = false;
    let heroHidden    = false;

    const TX_ELS = () => [
      D.heroMenu, D.catOverlay, D.catTitle, D.catInfo,
      D.catScrollHint, D.catGallery, D.contactOverlay,
    ].filter(Boolean);

    function goto(newState, opts = {}) {
      if (transitioning) return;
      const from = appState, to = newState;
      if (from === S.CAT && to === S.CAT && opts.cat === activeCat) return;
      gsap.killTweensOf(TX_ELS());
      transitioning = true;
      function done() { appState = to; if (to === S.CAT) activeCat = opts.cat; transitioning = false; }
      if (from === S.CAT && to === S.CAT) return _swapCat(opts.cat, opts.filter, done);
      const route = `${from}→${to}`;
      switch (route) {
        case `${S.HERO}→${S.CAT}`:     return _heroToCat(opts.cat, opts.filter, done);
        case `${S.CAT}→${S.HERO}`:     return _catToHero(done);
        case `${S.HERO}→${S.CONTACT}`: return _heroToContact(done);
        case `${S.CONTACT}→${S.HERO}`: return _contactToHero(done);
        case `${S.CAT}→${S.CONTACT}`:  return _catToContact(done);
        case `${S.CONTACT}→${S.CAT}`:  return _contactToCat(opts.cat, opts.filter, done);
        default: done();
      }
    }

    function _heroToCat(cat, filter, done) {
      _buildCat(cat, filter || CAT_MAP[cat] || cat);
      _setBack(true); _setCatActive(cat);
      document.body.classList.add('cat-open');
      document.body.style.overflow = 'hidden';
      gsap.to(D.heroMenu, { opacity: 0, duration: 0.45, ease: 'power2.inOut',
        onComplete() {
          heroHidden = true; _navSolid(true);
          D.catOverlay.classList.add('open');
          gsap.set(D.catOverlay, { opacity: 1 });
          _revealCat(() => { setTimeout(() => _catUpdateInfo(catCurIdx), 180); done(); });
        },
      });
    }

    function _catToHero(done) {
      _setCatActive(null); _setBack(false);
      document.body.classList.remove('cat-open');
      document.body.style.overflow = '';
      _navSolid(false);
      gsap.to([D.catInfo, D.catTitle, D.catScrollHint], { opacity: 0, duration: 0.15 });
      gsap.to(D.catOverlay, { opacity: 0, y: -18, duration: 0.42, ease: 'power3.in', delay: 0.05,
        onComplete() {
          D.catOverlay.classList.remove('open');
          gsap.set(D.catOverlay, { clearProps: 'y,opacity' });
          gsap.set([D.catTitle, D.catInfo], { clearProps: 'opacity,transform' });
          _revealHero(done);
        },
      });
    }

    function _heroToContact(done) {
      _setBack(true); _navSolid(true);
      document.body.classList.add('contact-open');
      document.body.style.overflow = 'hidden';
      D.contactOverlay.classList.add('open');
      gsap.to(D.heroMenu, { opacity: 0, duration: 0.4, ease: 'power2.inOut',
        onComplete() { heroHidden = true; _revealContact(done); },
      });
    }

    function _contactToHero(done) {
      _setBack(false); _navSolid(false);
      document.body.classList.remove('contact-open');
      document.body.style.overflow = '';
      gsap.to(D.contactOverlay, { opacity: 0, duration: 0.35, ease: 'power2.in',
        onComplete() {
          D.contactOverlay.classList.remove('open');
          gsap.set(D.contactOverlay, { clearProps: 'opacity' });
          _revealHero(done);
        },
      });
    }

    function _catToContact(done) {
      _setCatActive(null);
      document.body.classList.remove('cat-open');
      document.body.classList.add('contact-open');
      gsap.to([D.catInfo, D.catTitle, D.catScrollHint], { opacity: 0, duration: 0.15 });
      gsap.to(D.catOverlay, { opacity: 0, duration: 0.32, ease: 'power3.in', delay: 0.05,
        onComplete() {
          D.catOverlay.classList.remove('open');
          gsap.set(D.catOverlay, { clearProps: 'opacity,y' });
          gsap.set([D.catTitle, D.catInfo], { clearProps: 'opacity,transform' });
          D.contactOverlay.classList.add('open');
          _revealContact(done);
        },
      });
    }

    function _contactToCat(cat, filter, done) {
      _buildCat(cat, filter || CAT_MAP[cat] || cat);
      _setCatActive(cat);
      document.body.classList.remove('contact-open');
      document.body.classList.add('cat-open');
      gsap.to(D.contactOverlay, { opacity: 0, duration: 0.3, ease: 'power2.in',
        onComplete() {
          D.contactOverlay.classList.remove('open');
          gsap.set(D.contactOverlay, { clearProps: 'opacity' });
          D.catOverlay.classList.add('open');
          gsap.set(D.catOverlay, { opacity: 1 });
          _revealCat(() => { setTimeout(() => _catUpdateInfo(catCurIdx), 180); done(); });
        },
      });
    }

    function _swapCat(cat, filter, done) {
      _setCatActive(cat);
      gsap.to([D.catTitle, D.catInfo, D.catGallery], { opacity: 0, duration: 0.2, ease: 'power2.in',
        onComplete() {
          _buildCat(cat, filter || CAT_MAP[cat] || cat);
          gsap.killTweensOf(D.catTitle);
          gsap.fromTo(D.catTitle,
            { clipPath: 'inset(0 100% 0 0%)' },
            { clipPath: 'inset(0 0% 0 0%)', duration: 0.6, ease: 'expo.out',
              onComplete() { gsap.set(D.catTitle, { clearProps: 'all' }); } });
          gsap.fromTo(D.catGallery, { opacity: 0 },
            { opacity: 1, duration: 0.55, ease: 'power2.out', delay: 0.15,
              onComplete() { gsap.set(D.catGallery, { clearProps: 'opacity' }); } });
          gsap.set(D.catInfo, { opacity: 0 });
          setTimeout(() => _catUpdateInfo(catCurIdx), 300);
          done();
        },
      });
    }

    function _revealHero(cb) {
      heroHidden = false;
      gsap.to(D.heroMenu, { opacity: 1, duration: 0.35, ease: 'power2.out', delay: 0.05, onComplete: cb || null });
      const hc = $('heroCard');
      if (hc) gsap.fromTo(hc, { y: 40, scale: 0.94 }, { y: 0, scale: 1, duration: 1.4, ease: 'elastic.out(1,.42)', delay: 0.08 });
    }

    function _revealCat(cb) {
      gsap.set(D.catTitle, { opacity: 0, y: 22 });
      gsap.set(D.catInfo,  { opacity: 0 });
      gsap.set(D.catScrollHint, { opacity: 0 });
      gsap.to(D.catTitle, { opacity: 1, y: 0, duration: 0.65, ease: 'expo.out', delay: 0.08,
        onComplete() { gsap.set(D.catTitle, { clearProps: 'transform,opacity' }); } });
      gsap.to(D.catScrollHint, { opacity: 1, duration: 0.7, ease: 'power2.out', delay: 0.4 });
      if (cb) setTimeout(cb, 100);
    }

    function initContactForm() {
      var form = document.getElementById('ContactForm');
      if (!form || form.dataset.ajaxBound) return;
      form.dataset.ajaxBound = '1';
      form.onsubmit = function (e) {
        e.preventDefault(); e.stopImmediatePropagation();
        var btn = form.querySelector('[type="submit"]');
        if (btn) btn.disabled = true;
        fetch('/contact', {
          method: 'POST',
          headers: { 'Accept': 'text/html,application/xhtml+xml,application/xml;q=0.9,*/*;q=0.8', 'X-Requested-With': 'XMLHttpRequest' },
          credentials: 'same-origin',
          body: new FormData(form)
        })
        .then(r => r.text())
        .then(() => {
          var fields = document.getElementById('contactFormFields');
          var success = document.getElementById('contactSuccess');
          if (fields) fields.style.display = 'none';
          if (success) success.style.display = 'block';
        })
        .catch(() => { if (btn) btn.disabled = false; });
        return false;
      };
    }

    function _revealContact(cb) {
      gsap.set(D.contactOverlay, { opacity: 1 });
      const els = [
        D.contactOverlay.querySelector('.contact-page__left'),
        D.contactOverlay.querySelector('.contact-page__right'),
      ].filter(Boolean);
      gsap.fromTo(els, { opacity: 0, y: 18 }, {
        opacity: 1, y: 0, duration: 0.6, ease: 'expo.out', stagger: 0.07,
        onComplete() {
          els.forEach(el => gsap.set(el, { clearProps: 'transform,opacity' }));
          if (cb) cb();
          initContactForm();
        },
      });
    }

    function _navSolid(on) { D.nav && D.nav.classList.toggle('nav--solid', on); }
    function _setBack(visible) { D.navCatBack && D.navCatBack.classList.toggle('visible', visible); }
    function _setCatActive(catName) {
      $$('.nav__cat').forEach(el => {
        el.classList.toggle('active', !!(catName && (el.dataset.cat === catName || el.textContent.trim() === catName)));
      });
    }

    D.navCatBack && D.navCatBack.addEventListener('click', () => { if (transitioning) return; goto(S.HERO); });
    $$('.nav__cat').forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        if (transitioning) return;
        const name = link.dataset.cat || link.textContent.trim();
        if (name === 'Contact') goto(S.CONTACT);
        else goto(S.CAT, { cat: name, filter: CAT_MAP[name] || name });
      });
    });
    D.hamburgerBtn   && D.hamburgerBtn.addEventListener('click',   () => D.mobileNav?.classList.add('open'));
    D.mobileNavClose && D.mobileNavClose.addEventListener('click', () => D.mobileNav?.classList.remove('open'));
    $$('.mobile-nav__link').forEach(btn => {
      btn.addEventListener('click', () => {
        D.mobileNav?.classList.remove('open');
        const cat = btn.dataset.cat;
        if (cat === 'Contact') goto(S.CONTACT);
        else goto(S.CAT, { cat, filter: CAT_MAP[cat] || cat });
      });
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') {
        if (prodIsOpen) { closeProduct(); return; }
        if (appState !== S.HERO && !transitioning) { goto(S.HERO); return; }
        closeBag(); closeSearch();
      }
    });

    /* ═══════════════════════════════════════════════════
       CATEGORY GALLERY
    ═══════════════════════════════════════════════════ */
    let CAT_W = 162, CAT_GAP = 110, CAT_STEP = 272;
    let S_ACT = 2.05, S_IDL = 0.68, OP_ACT = 1, OP_IDL = 0.38, INTERP = 299.2;

    function _refreshCatDims() {
      if (window.innerWidth <= 900) {
        CAT_W = Math.floor(window.innerWidth * 0.76);
        CAT_GAP = Math.floor(window.innerWidth * 0.12);
        CAT_STEP = CAT_W + CAT_GAP;
        S_ACT = 1.0; S_IDL = 0.72; OP_ACT = 1; OP_IDL = 0.55;
        INTERP = CAT_STEP * 1.1;
      } else {
        CAT_W = 162; CAT_GAP = 110; CAT_STEP = 272;
        S_ACT = 2.05; S_IDL = 0.68; OP_ACT = 1; OP_IDL = 0.38;
        INTERP = 299.2;
      }
    }

    let catItems    = [];
    let catCurIdx   = 0;
    let catOffset   = 0;
    let catDragging = false, catDragX0 = 0, catDragOff0 = 0, catDragMoved = false;
    const catProxy  = { v: 0 };

    function _buildCat(catName, filter) {
      if (!D.catTrack) return;
      _refreshCatDims();
      D.catTrack.innerHTML = '';
      catItems = []; catCurIdx = 0;
      if (D.catTitle) D.catTitle.textContent = catName.toUpperCase();
      const primary = PRODUCTS.filter(p => p.cat.toUpperCase() === filter.toUpperCase());
      const detailCloseBtn = document.getElementById('detailClose');
      if (detailCloseBtn) detailCloseBtn.onclick = () => { document.getElementById('detailOverlay').classList.remove('open'); };
      const detailOverlay = document.getElementById('detailOverlay');
      if (detailOverlay) detailOverlay.addEventListener('click', e => { if (e.target.id === 'detailOverlay') e.target.classList.remove('open'); });
      primary.forEach((p, i) => {
        const el = document.createElement('div');
        el.className = 'cat-item';
        el.style.marginRight = i < primary.length - 1 ? `${CAT_GAP}px` : '0';
        el.innerHTML = `<div class="cat-item__img-wrap"><img class="cat-item__img" src="${p.src}" alt="${p.title}" loading="eager"></div>`;
        D.catTrack.appendChild(el);
        catItems.push({ el, product: p });
      });
      catItems.forEach((item, i) => {
        item.el.addEventListener('click', () => { if (!catDragMoved) catGoTo(i); });
      });
      const gallW = (D.catGallery ? D.catGallery.offsetWidth : window.innerWidth) || window.innerWidth;
      catOffset = gallW / 2 - CAT_W / 2;
      catProxy.v = catOffset;
      if (D.catTrack) D.catTrack.style.transform = `translateX(${catOffset}px)`;
      _catUpdateScale();
    }

    function _catUpdateScale() {
      if (!catItems.length || !D.catGallery) return;
      const cx = D.catGallery.offsetWidth / 2;
      catItems.forEach((it, i) => {
        const itemCX = i * CAT_STEP + catOffset + CAT_W / 2;
        const dist   = Math.abs(itemCX - cx);
        const t      = Math.min(dist / INTERP, 1);
        const tE     = Math.pow(t, 1.6);
        const sc     = S_ACT - (S_ACT - S_IDL) * tE;
        const op     = OP_ACT - (OP_ACT - OP_IDL) * tE;
        it.el.style.transform = `scale(${sc.toFixed(4)})`;
        it.el.style.opacity   = op.toFixed(4);
      });
    }

    function _catUpdateInfo(idx) {
      if (!catItems.length) return;
      const p   = catItems[idx].product;
      const tot = catItems.length;
      gsap.to(D.catInfo, { opacity: 0, duration: 0.12,
        onComplete() {
          if (D.catInfoCounter) D.catInfoCounter.textContent = `${String(idx + 1).padStart(2, '0')} / ${String(tot).padStart(2, '0')}`;
          if (D.catInfoName)    D.catInfoName.textContent    = p.title;
          if (D.catInfoBrand)   D.catInfoBrand.textContent   = '';
                    


                    if (D.catInfoPrice) {
  const catVarWrap = document.getElementById('catVariantWrap');
  if (catVarWrap) {
    catVarWrap.innerHTML = '';
    const isDefault = !p.variants || (p.variants.length === 1 && p.variants[0].title === 'Default Title');
    catVarWrap.style.display = isDefault ? 'none' : '';
    if (!isDefault) {
      p.variants.forEach(function(fv, i) {
        const btn = document.createElement('button');
        btn.className = 'cat-var-btn' + (i === 0 ? ' active' : '') + (!fv.available ? ' sold-out' : '');
        btn.textContent = fv.title;
        btn.dataset.variantId = fv.id;
        btn.addEventListener('click', function(e) {
          e.stopPropagation();
          catVarWrap.querySelectorAll('.cat-var-btn').forEach(function(b) { b.classList.remove('active'); });
          const qv = document.getElementById('catQtyVal'); if (qv) qv.textContent = '1';
          btn.classList.add('active');
          const vndPrice = (fv.price / 100).toLocaleString('vi-VN') + '₫';
          D.catInfoPrice.textContent = vndPrice;
          if (D.catInfoAtb) {
            D.catInfoAtb.textContent = !fv.available ? STR.soldOut : STR.prodAtb;
            D.catInfoAtb.disabled = !fv.available;
            D.catInfoAtb.classList.toggle('sold-out', !fv.available);
            const updated = Object.assign({}, p, { variantId: fv.id, available: fv.available });
            D.catInfoAtb.dataset.product = JSON.stringify(updated);
          }
        });
        catVarWrap.appendChild(btn);
      });
    }
  }
  const first = p.variants ? p.variants[0] : null;
  if (first) {
    const vndPrice = (first.price / 100).toLocaleString('vi-VN') + '₫';
    D.catInfoPrice.textContent = vndPrice;
    if (D.catInfoAtb) {
      D.catInfoAtb.textContent = !first.available ? STR.soldOut : STR.prodAtb;
      D.catInfoAtb.disabled = !first.available;
      D.catInfoAtb.classList.toggle('sold-out', !first.available);
      const updated = Object.assign({}, p, { variantId: first.id, available: first.available });
      D.catInfoAtb.dataset.product = JSON.stringify(updated);
    }
  }
}



          const cvdBtn = document.getElementById('catViewDetails');
          if (cvdBtn) cvdBtn.onclick = () => {
            window._lastP = p;
            const overlay = document.getElementById('detailOverlay');
            const desc = document.getElementById('detailDesc');
            if (desc) desc.textContent = p.desc || '';
            ['detail1','detail2','detail3','detail4'].forEach((key, i) => {
              const slot = document.getElementById('detailPhoto' + (i + 1));
              if (slot) slot.innerHTML = p[key] ? `<img src="${p[key]}" style="width:100%;height:100%;object-fit:cover">` : '';
            });
            if (overlay) {
              overlay.classList.add('open');
              document.body.style.overflow = 'hidden';
              overlay.addEventListener('wheel', e => { e.preventDefault(); e.stopPropagation(); }, {passive:false});
              overlay.addEventListener('touchmove', e => e.preventDefault(), {passive:false});
            }
            const carousel = document.getElementById('detailCarousel');
            const prevBtn = document.getElementById('detailPrev');
            const nextBtn = document.getElementById('detailNext');
            let _detailIdx = 0;
            let _detailWheelLock = false;
            const _detailSlides = ['detailPhoto1','detailPhoto2','detailPhoto3','detailPhoto4'];
            const _detailGoTo = (idx2) => {
              const slides = _detailSlides.map(id => document.getElementById(id)).filter(el => el && el.innerHTML.trim() !== '');
              if (!slides.length) return;
              const len = slides.length;
              _detailIdx = ((idx2 % len) + len) % len;
              carousel.style.transition = 'opacity 0.3s ease';
              carousel.style.opacity = '0';
              setTimeout(() => { carousel.scrollTo({left: _detailIdx * carousel.offsetWidth, behavior:'instant'}); carousel.style.opacity = '1'; }, 300);
            };
            const _detailNav = (dir) => _detailGoTo(_detailIdx + dir);
            if (prevBtn) prevBtn.onclick = () => _detailNav(-1);
            if (nextBtn) nextBtn.onclick = () => _detailNav(1);
            const _detailKeyHandler = (e) => {
              if (!document.getElementById('detailOverlay')?.classList.contains('open')) return;
              if (e.key === 'ArrowRight') { e.preventDefault(); _detailNav(1); }
              if (e.key === 'ArrowLeft')  { e.preventDefault(); _detailNav(-1); }
            };
            const _detailWheelHandler = (e) => {
              e.preventDefault(); e.stopPropagation();
              if (_detailWheelLock) return;
              _detailWheelLock = true;
              setTimeout(() => { _detailWheelLock = false; }, 600);
              _detailNav(e.deltaY > 0 ? 1 : -1);
            };
            document.removeEventListener('keydown', _detailKeyHandler);
            document.addEventListener('keydown', _detailKeyHandler);
            if (carousel) {
              carousel.removeEventListener('wheel', _detailWheelHandler);
              carousel.addEventListener('wheel', _detailWheelHandler, {passive:false});
              carousel.scrollTo({left: 0, behavior:'smooth'});
            }
            if (overlay) { overlay.setAttribute('tabindex', '0'); overlay.focus(); }
          };

          if (D.catInfoStock) D.catInfoStock.textContent = p.stock || '';
          const qv = $('catQtyVal');
          if (qv) qv.textContent = '1';
          if (D.catInfoAtb) D.catInfoAtb.dataset.product = JSON.stringify(p);
          gsap.to(D.catInfo, { opacity: 1, duration: 0.25, ease: 'power2.out' });
        },
      });
    }
    function catGoTo(idx) {
      if (!catItems.length) return;
      idx = Math.max(0, Math.min(catItems.length - 1, idx));
      catCurIdx = idx;
      const gallW  = D.catGallery ? D.catGallery.offsetWidth : window.innerWidth;
      const target = gallW / 2 - idx * CAT_STEP - CAT_W / 2;
      gsap.killTweensOf(catProxy);
      catProxy.v = catOffset;
      gsap.to(catProxy, { v: target, duration: 0.78, ease: 'expo.out',
        onUpdate() { catOffset = catProxy.v; } });
      _catUpdateInfo(idx);
    }

    gsap.ticker.add(() => {
      if (appState !== S.CAT || !catItems.length || !D.catTrack) return;
      D.catTrack.style.transform = `translateX(${catOffset}px)`;
      _catUpdateScale();
    });
 


    if (D.catGallery) {
      let catWheelLock = false;
      D.catGallery.addEventListener('wheel', e => {
        if (appState !== S.CAT) return;
        e.preventDefault();
        if (catWheelLock) return;
        catWheelLock = true;
        setTimeout(() => { catWheelLock = false; }, 320);
        catGoTo(catCurIdx + (e.deltaY > 0 ? 1 : -1));
      }, { passive: false });
      D.catGallery.addEventListener('mousedown', e => {
        if (e.button !== 0 || appState !== S.CAT) return;
        catDragging = true; catDragMoved = false;
        catDragX0 = e.clientX; catDragOff0 = catOffset;
        gsap.killTweensOf(catProxy);
        D.catGallery.classList.add('grabbing');
        e.preventDefault();
      });
      D.catGallery.addEventListener('touchstart', e => {
        if (appState !== S.CAT) return;
        const t = e.touches[0];
        catDragging = true; catDragMoved = false;
        catDragX0 = t.clientX; catDragOff0 = catOffset;
        gsap.killTweensOf(catProxy);
      }, { passive: true });
      D.catGallery.addEventListener('touchmove', e => {
        if (!catDragging) return;
        const dx = e.touches[0].clientX - catDragX0;
        if (Math.abs(dx) > 6) catDragMoved = true;
        catOffset = catDragOff0 + dx;
        e.preventDefault();
      }, { passive: false });
      D.catGallery.addEventListener('touchend', () => {
        if (!catDragging) return;
        catDragging = false;
        D.catGallery.classList.remove('grabbing');
        if (catDragMoved) _catSnapNearest();
        setTimeout(() => { catDragMoved = false; }, 40);
      }, { passive: true });
    }

    document.addEventListener('mousemove', e => {
      if (!catDragging) return;
      const dx = e.clientX - catDragX0;
      if (Math.abs(dx) > 6) catDragMoved = true;
      catOffset = catDragOff0 + dx;
    });
    document.addEventListener('mouseup', () => {
      if (!catDragging) return;
      catDragging = false;
      D.catGallery && D.catGallery.classList.remove('grabbing');
      if (catDragMoved) _catSnapNearest();
      setTimeout(() => { catDragMoved = false; }, 40);
    });

    function _catSnapNearest() {
      const gallW = (D.catGallery ? D.catGallery.offsetWidth : window.innerWidth) || window.innerWidth;
      const cx = gallW / 2;
      let nearest = 0, nearDist = Infinity;
      catItems.forEach((_, i) => {
        const d = Math.abs(i * CAT_STEP + catOffset + CAT_W / 2 - cx);
        if (d < nearDist) { nearDist = d; nearest = i; }
      });
      catGoTo(nearest);
    }

    let catKeyLock = false;
    document.addEventListener('keydown', e => {
      if (appState !== S.CAT) return;
      if (document.getElementById('detailOverlay')?.classList.contains('open')) return;
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        if (catKeyLock) return;
        catKeyLock = true;
        setTimeout(() => { catKeyLock = false; }, 420);
        catGoTo(catCurIdx + (e.key === 'ArrowRight' ? 1 : -1));
      }
    });

    D.catInfoAtb && D.catInfoAtb.addEventListener('click', function () {
  if (this.disabled || this._adding) return;
  this._adding = true;
  const btn = this;
  const p = JSON.parse(this.dataset.product || 'null');
  if (!p) { btn._adding = false; return; }
  if (p.available === false) { btn._adding = false; return; }
  const qty = parseInt(document.getElementById('catQtyVal')?.textContent || 1);
  const max = (p.qty > 0) ? p.qty : 999;
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      const inCart = cart.items.filter(i => i.variant_id == p.variantId).reduce((s, i) => s + i.quantity, 0);
      if (inCart + qty > max) {
        const orig = btn.textContent;
        btn.textContent = 'Max quantity already in cart.';
        setTimeout(() => { btn.textContent = orig; btn._adding = false; }, 2500);
      } else {
        addToBag(p, qty);
        const orig = btn.textContent;
        btn.textContent = STR.added;
        setTimeout(() => { btn.textContent = orig; btn._adding = false; }, 1400);
      }
    })
    .catch(() => { btn._adding = false; });
});

    /* ═══════════════════════════════════════════════════
       HERO CAROUSEL (reel)
    ═══════════════════════════════════════════════════ */
    const CARD_W = 281, CARD_H = 398, GAP = 44, STEP = CARD_W + GAP;
    const N = PRODUCTS.length, SETS = 3, LOOP_W = N * STEP;
    const reel = $('reel');
    let reelItems = [], popStates = [], hoverScales = [];
    let reelOffset = N > 0 ? -LOOP_W + window.innerWidth / 2 - CARD_W / 2 - STEP : 0;
    let vel = 0, reelDrag = false, reelDragX0 = 0, reelDragOff0 = 0;
    let reelDragMoved = false, reelDragVX = 0;
    let reelActive = false;
    const AUTO_SPD = 0.5;
    const keysHeld = new Set();

    function _reelNorm() {
      const cx = window.innerWidth / 2 - CARD_W / 2;
      while (reelOffset < -LOOP_W * 2 + cx) reelOffset += LOOP_W;
      while (reelOffset >  LOOP_W + cx)      reelOffset -= LOOP_W;
    }

    if (N > 0 && reel) {
      for (let s = 0; s < SETS; s++) {
        for (let i = 0; i < N; i++) {
          const p = PRODUCTS[i];
          const slide = document.createElement('div');
          slide.className = 'c-slide';
          slide.innerHTML = `<div class="hs-inner"><div class="hs-img-wrap"><img class="hs-img" src="${p.src}" alt="${p.title}" loading="lazy"><div class="hs-grad"></div></div><div class="hs-divider"></div><div class="hs-info"><span class="hs-cat">${p.cat}</span><span class="hs-title">${p.title}</span><span class="hs-brand">${p.brand}</span><span class="hs-price">${p.price}</span></div></div>`;
          reel.appendChild(slide);
          reelItems.push(slide);
          popStates.push({ progress: 0, offsetY: 80 });
          hoverScales.push({ scale: 1 });
          const idx = s * N + i;
          slide.addEventListener('mouseenter', () => gsap.to(hoverScales[idx], { scale: 1.09, duration: 0.35, ease: 'power2.out' }));
          slide.addEventListener('mouseleave', () => gsap.to(hoverScales[idx], { scale: 1,    duration: 0.35, ease: 'power2.out' }));
          slide.addEventListener('click', () => {
            if (reelDragMoved) return;
            goto(S.CAT, { cat: p.cat, filter: CAT_MAP[p.cat] || p.cat });
            setTimeout(() => {
              const pidx = catItems.findIndex(it => it.product.title === p.title);
              if (pidx >= 0) catGoTo(pidx);
            }, 350);
          });
        }
      }

      reel.addEventListener('wheel', e => {
        if (appState !== S.HERO) return;
        e.preventDefault();
        vel -= e.deltaY * 0.38;
        vel = Math.max(-45, Math.min(45, vel));
      }, { passive: false });

      reel.addEventListener('mousedown', e => {
        if (e.button !== 0 || appState !== S.HERO) return;
        reelDrag = true; reelDragMoved = false;
        reelDragX0 = e.clientX; reelDragOff0 = reelOffset;
        reelDragVX = 0; vel = 0;
        e.preventDefault();
      });
    }

    document.addEventListener('mousemove', e => {
      if (!reelDrag) return;
      const dx = e.clientX - reelDragX0;
      if (Math.abs(dx) > 6) reelDragMoved = true;
      reelOffset = reelDragOff0 + dx;
      reelDragVX = e.movementX * 0.65;
    });
    document.addEventListener('mouseup', () => {
      if (!reelDrag) return;
      reelDrag = false;
      vel = Math.max(-30, Math.min(30, reelDragVX));
      setTimeout(() => { reelDragMoved = false; }, 40);
    });
    document.addEventListener('keydown', e => {
      if (document.getElementById('detailOverlay')?.classList.contains('open')) {
        if (['ArrowLeft', 'ArrowRight', '4', '6'].includes(e.key)) e.preventDefault();
        return;
      }
      if (appState !== S.HERO) return;
      if (['ArrowLeft', 'ArrowRight', '4', '6'].includes(e.key)) { keysHeld.add(e.key); e.preventDefault(); }
    });
    document.addEventListener('keyup', e => { if (document.getElementById('detailOverlay')?.classList.contains('open')) { keysHeld.clear(); return; } keysHeld.delete(e.key); });

    gsap.ticker.lagSmoothing(0);
    gsap.ticker.add(() => {
      if (document.getElementById('detailOverlay')?.classList.contains('open')) { keysHeld.clear(); vel = 0; return; }
      if (!reelActive || appState !== S.HERO || N === 0) return;
      if (keysHeld.has('ArrowRight') || keysHeld.has('6')) { reelOffset -= 4; _reelNorm(); }
      if (keysHeld.has('ArrowLeft')  || keysHeld.has('4')) { reelOffset += 4; _reelNorm(); }
      if (!reelDrag) {
        vel *= 0.91;
        if (Math.abs(vel) < 0.02) vel = 0;
        reelOffset -= AUTO_SPD;
        reelOffset += vel;
        _reelNorm();
      }
      const vcx = window.innerWidth / 2, vcy = window.innerHeight / 2;
      reelItems.forEach((card, idx) => {
        const lx = (idx % (N * SETS)) * STEP + reelOffset;
        if (lx < -CARD_W * 2 || lx > window.innerWidth + CARD_W) { card.style.opacity = '0'; return; }
        const cx2 = lx + CARD_W / 2, t = (cx2 - vcx) / STEP, abs = Math.abs(t);
        const sc  = Math.max(0.28, Math.pow(0.58, abs));
        const op  = Math.max(0.15, Math.pow(0.65, abs));
        const pop = popStates[idx], hov = hoverScales[idx].scale;
        const finalSc = sc * hov, finalY = vcy - CARD_H / 2 + pop.offsetY;
        const ry = Math.max(-52, Math.min(52, t * 38));
        card.style.transform = `translate(${lx + CARD_W / 2}px,${finalY + CARD_H / 2}px) perspective(900px) rotateY(${ry}deg) scale(${finalSc}) translate(${-CARD_W / 2}px,${-CARD_H / 2}px)`;
        card.style.opacity   = String(op * pop.progress);
        card.style.zIndex    = String(Math.round(100 - abs * 10));
      });
    });

    /* ═══════════════════════════════════════════════════
       PRODUCT MODAL
    ═══════════════════════════════════════════════════ */
    let prodIsOpen = false;

    function openProduct(p) {
      prodIsOpen = true;
      const img = $('prodImg');
      if (img) { img.src = p.src; img.alt = p.title; }
      [['prodCat', p.cat ? p.cat.toUpperCase() : ''],
       ['prodTitle', p.title], ['prodBrand', ''],
       ['prodPrice', p.price], ['prodDesc', p.desc || '']].forEach(([id, val]) => {
        const el = $(id); if (el) el.textContent = val;
      });
      const stockEl = $('prodStock');
      if (stockEl) {
        stockEl.textContent = p.stock || STR.inStock;
        stockEl.style.color = (p.stock && p.stock.toLowerCase().includes('low')) ? 'rgba(220,160,80,.85)' : 'rgba(160,210,140,.7)';
      }
      const specsEl = $('prodSpecs');
      if (specsEl) {
        specsEl.innerHTML = '';
        (p.specs || []).forEach(s => {
          specsEl.innerHTML += `<div class="prod-modal__spec-row"><span class="prod-modal__spec-key">${s[0]}</span><span class="prod-modal__spec-val">${s[1]}</span></div>`;
        });
      }
      const qv = $('prodQtyVal'); if (qv) qv.textContent = '1';
      const atb = $('prodAtb');   if (atb) atb.dataset.product = JSON.stringify(p);
      D.prodOverlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      gsap.fromTo(D.prodOverlay, { opacity: 0 }, { opacity: 1, duration: 0.45, ease: 'power2.out' });
      const modal = D.prodOverlay.querySelector('.prod-modal');
      if (modal) gsap.fromTo(modal, { clipPath: 'inset(0 100% 0 0%)' }, { clipPath: 'inset(0 0% 0 0%)', duration: 0.75, ease: 'expo.out', delay: 0.1, onComplete() { gsap.set(modal, { clearProps: 'clipPath' }); } });
      const imgSide = D.prodOverlay.querySelector('.prod-modal__img-side');
      if (imgSide) gsap.fromTo(imgSide, { opacity: 0 }, { opacity: 1, duration: 0.65, ease: 'power2.out', delay: 0.3 });
      const infoEls = ['.prod-modal__cat', '.prod-modal__title', '.prod-modal__brand', '.prod-modal__price', '.prod-modal__desc', '.prod-modal__atb'].map(sel => D.prodOverlay.querySelector(sel)).filter(Boolean);
      gsap.fromTo(infoEls, { opacity: 0, y: 8 }, { opacity: 1, y: 0, duration: 0.55, ease: 'power3.out', stagger: 0.05, delay: 0.45, onComplete() { infoEls.forEach(el => gsap.set(el, { clearProps: 'transform,opacity' })); } });
    }

    function closeProduct() {
      if (!prodIsOpen) return;
      prodIsOpen = false;
      document.body.style.overflow = appState !== S.HERO ? 'hidden' : '';
      gsap.to(D.prodOverlay, { opacity: 0, duration: 0.38, ease: 'power2.in',
        onComplete() { D.prodOverlay.classList.remove('open'); } });
    }

    const prodClose = $('prodClose');
    prodClose && prodClose.addEventListener('click', closeProduct);
    D.prodOverlay && D.prodOverlay.addEventListener('click', e => { if (e.target === D.prodOverlay) closeProduct(); });

    const prodAtbBtn = $('prodAtb');
    prodAtbBtn && prodAtbBtn.addEventListener('click', function () {
      const p = JSON.parse(this.dataset.product || 'null'); if (!p) return;
      const qty = parseInt($('prodQtyVal')?.textContent || 1);
      const max = (p.inventory_quantity > 0) ? p.inventory_quantity : (p.qty > 0 ? p.qty : 999);
      const btn = this;
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          const inCart = cart.items.filter(i => i.variant_id == p.variantId).reduce((s, i) => s + i.quantity, 0);
          if (inCart + qty > max) {
            const orig = btn.textContent;
            btn.textContent = 'Max quantity already in cart.';
            setTimeout(() => { btn.textContent = orig; }, 2500);
          } else {
            addToBag(p, qty);
            const orig = btn.textContent;
            btn.textContent = STR.added;
            btn.classList.add('adding');
            setTimeout(() => { btn.textContent = orig; btn.classList.remove('adding'); }, 1400);
          }
        })
        .catch(e => console.error('[Phantasy] prodAtb:', e));
    });

    /* ═══════════════════════════════════════════════════
       QTY CONTROLS
    ═══════════════════════════════════════════════════ */
    [['prodQtyMinus', 'prodQtyVal', 'prodQtyPlus'],
     ['catQtyMinus',  'catQtyVal',  'catQtyPlus']].forEach(([minId, valId, plusId]) => {
      const minus = $(minId), val = $(valId), plus = $(plusId);
      if (!minus || !val || !plus) return;
      minus.addEventListener('click', () => { const n = parseInt(val.textContent) || 1; if (n > 1) val.textContent = n - 1; });
      plus.addEventListener('click', () => {
        const current = parseInt(val.textContent) || 1;
        const atbBtn = plusId === 'catQtyPlus' ? document.getElementById('catInfoAtb') : document.getElementById('prodAtb');
        const p = atbBtn ? JSON.parse(atbBtn.dataset.product || 'null') : null;
        const max = p ? (p.qty > 0 ? p.qty : (p.inventory_quantity || 999)) : 999;
        if (current >= max) {
          const container = atbBtn ? atbBtn.parentNode : plus.parentNode;
          const existingWarn = container.querySelector('.prod-qty__warn');
          if (existingWarn) existingWarn.remove();
          const warn = document.createElement('span');
          warn.className = 'prod-qty__warn';
          warn.textContent = `Max: ${max} in cart.`;
          warn.style.cssText = 'display:block;font-size:9px;letter-spacing:.1em;text-transform:uppercase;font-family:"Space Mono",monospace;color:#c0392b;margin-top:6px;opacity:.85;';
          atbBtn ? atbBtn.after(warn) : plus.after(warn);
          setTimeout(() => { if (warn.parentNode) warn.remove(); }, 2500);
          return;
        }
        val.textContent = current + 1;
      });
    });

    /* ═══════════════════════════════════════════════════
       SHOPIFY AJAX CART
    ═══════════════════════════════════════════════════ */
    function formatMoney(cents) {
      if (typeof cents !== 'number') return cents;
      return Math.round(cents / 100).toLocaleString('vi-VN') + '₫';
    }

    function refreshCart() {
      fetch(ROUTES.cartGet)
        .then(r => r.json())
        .then(renderCart)
        .catch(e => console.error('[Phantasy] cart:', e));
    }

    function renderCart(cart) {
      if (!D.bagBody) return;
      D.bagBody.querySelectorAll('.bag-item').forEach(el => el.remove());
            if (!cart || cart.item_count === 0) {
        if (D.bagEmpty)        D.bagEmpty.style.display = '';
        if (D.bagSubtotalRow)  D.bagSubtotalRow.style.display = 'none';
        if (D.bagCount)        { D.bagCount.classList.remove('visible'); D.bagCount.textContent = '0'; }
        if (D.bagCheckout)     D.bagCheckout.disabled = true;
        return;
      }
      if (D.bagEmpty)       D.bagEmpty.style.display = 'none';
      if (D.bagSubtotalRow) D.bagSubtotalRow.style.display = '';
            if (D.bagSubtotalVal) D.bagSubtotalVal.textContent = formatMoney(cart.total_price);

            if (D.bagCount) { D.bagCount.textContent = cart.item_count; D.bagCount.classList.add('visible'); }
      if (D.bagCheckout) D.bagCheckout.disabled = false;

      
      cart.items.forEach(item => {
        const div = document.createElement('div');
        div.className = 'bag-item';
        const src = item.image ? item.image.replace('http://', 'https://') : '';
        div.innerHTML = `<div class="bag-item__img-wrap">${src ? `<img class="bag-item__img" src="${src}" alt="${item.product_title}">` : ''}</div><div class="bag-item__info"><span class="bag-item__name">${item.product_title}</span>${item.variant_title && item.variant_title !== 'Default Title' ? `<span class="bag-item__variant">${item.variant_title}</span>` : ''}<span class="bag-item__brand"></span><div class="bag-item__qty-ctrl"><button class="bag-qty__btn bag-qty__minus" data-key="${item.key}">−</button><span class="bag-qty__val">${item.quantity}</span><button class="bag-qty__btn bag-qty__plus" data-key="${item.key}">+</button></div><span class="bag-item__price">${formatMoney(item.price)}</span></div><button class="bag-item__remove" data-key="${item.key}" aria-label="Remove"><svg viewBox="0 0 22 22" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"><path d="M4 4l14 14M18 4L4 18"/></svg></button>`;
        D.bagBody.appendChild(div);
        div.querySelector('.bag-qty__minus').addEventListener('click', function() {
          const n = div.querySelector('.bag-qty__val');
          const q = parseInt(n.textContent);
          fetch(ROUTES.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: item.key, quantity: q - 1 }) }).then(r => r.json()).then(renderCart);
        });
        div.querySelector('.bag-qty__plus').addEventListener('click', function() {
          const n = div.querySelector('.bag-qty__val');
          const q = parseInt(n.textContent);
          const phantasyProduct = (window.PHANTASY?.products || []).find(p => p.variants && p.variants.some(v => v.id == item.variant_id));
          const phantasyVariant = phantasyProduct?.variants?.find(v => v.id == item.variant_id);
          const variantQty = phantasyVariant ? parseInt(phantasyVariant.qty) : (phantasyProduct ? parseInt(phantasyProduct.qty) : null);
          const max = (variantQty != null && variantQty >= 0) ? variantQty : 999;
          if (q >= max) {
            const existingWarn = div.querySelector('.bag-qty__warn');
            if (existingWarn) existingWarn.remove();
            const warn = document.createElement('span');
            warn.className = 'bag-qty__warn';
            warn.textContent = 'Max quantity already in cart.';
            warn.style.cssText = 'display:block;font-size:9px;letter-spacing:.1em;text-transform:uppercase;font-family:"Space Mono",monospace;color:#c0392b;margin-top:6px;opacity:.85;';
            div.querySelector('.bag-item__qty-ctrl').after(warn);
            setTimeout(() => { if (warn.parentNode) warn.remove(); }, 2500);
            return;
          }
          fetch(ROUTES.cartChange, { method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({id: item.key, quantity: q + 1}) }).then(r => r.json()).then(renderCart);
        });
        div.querySelector('.bag-item__remove').addEventListener('click', function () {
          fetch(ROUTES.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: this.dataset.key, quantity: 0 }) })
            .then(r => r.json()).then(renderCart)
            .catch(e => console.error('[Phantasy] cart change:', e));
        });
      });
    }

    function addToBag(product, quantity = 1) {
      if (!product?.variantId) { console.warn('[Phantasy] no variantId', product); return; }
      fetch(ROUTES.cartAdd, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: product.variantId, quantity }) })
        .then(r => { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(() => {
          refreshCart();
          if (D.bagBtn)   gsap.fromTo(D.bagBtn,   { scale: 1.35 }, { scale: 1, duration: 0.5, ease: 'elastic.out(1,.5)' });
          if (D.bagCount) gsap.fromTo(D.bagCount, { scale: 1.6, opacity: 0 }, { scale: 1, opacity: 1, duration: 0.45, ease: 'back.out(2)' });
        })
        .catch(e => console.error('[Phantasy] add to cart:', e));
    }

    refreshCart();

    /* ═══════════════════════════════════════════════════
       BAG PANEL
    ═══════════════════════════════════════════════════ */
    function openBag() {
      if (!D.bagOverlay || !D.bagPanel) return;
      D.bagOverlay.classList.add('open');
      document.body.classList.add('bag-open');
      gsap.to(D.bagOverlay, { backgroundColor: 'rgba(0,0,0,.55)', duration: 0.55, ease: 'power2.out' });
      gsap.to(D.bagPanel,   { x: '0%', duration: 0.85, ease: 'expo.out' });
      const els = [D.bagPanel.querySelector('.bag-panel__head'), D.bagPanel.querySelector('.bag-panel__body'), D.bagSubtotalRow, D.bagPanel.querySelector('.bag-panel__foot')].filter(Boolean);
      gsap.fromTo(els, { opacity: 0, y: 10 }, { opacity: 1, y: 0, duration: 0.55, ease: 'power3.out', stagger: 0.06, delay: 0.38, onComplete() { els.forEach(el => gsap.set(el, { clearProps: 'transform,opacity' })); } });
    }

    function closeBag() {
      if (!D.bagOverlay || !D.bagPanel) return;
      const els = [D.bagPanel.querySelector('.bag-panel__foot'), D.bagSubtotalRow, D.bagPanel.querySelector('.bag-panel__body'), D.bagPanel.querySelector('.bag-panel__head')].filter(Boolean);
      gsap.to(els,          { opacity: 0, duration: 0.18 });
      gsap.to(D.bagPanel,   { x: '100%', duration: 0.6, ease: 'power3.in', delay: 0.08 });
      gsap.to(D.bagOverlay, { backgroundColor: 'rgba(0,0,0,0)', duration: 0.5, ease: 'power2.in', delay: 0.1,
        onComplete() { D.bagOverlay.classList.remove('open'); document.body.classList.remove('bag-open'); } });
    }

    D.searchInput && D.searchInput.addEventListener('focus', function() { if (window._pinching) D.searchInput.blur(); });
    D.bagBtn      && D.bagBtn.addEventListener('click', openBag);
    D.bagClose    && D.bagClose.addEventListener('click', closeBag);
    D.bagOverlay  && D.bagOverlay.addEventListener('click', closeBag);
    D.bagContinue && D.bagContinue.addEventListener('click', closeBag);
    D.bagCheckout && D.bagCheckout.addEventListener('click', () => { sessionStorage.setItem('openBagPanel', '1'); window.location.href = ROUTES.checkout; });


    /* ═══════════════════════════════════════════════════
       SEARCH
    ═══════════════════════════════════════════════════ */
    const searchInnerEls = D.searchOverlay ? [
      D.searchOverlay.querySelector('.search-label'),
      D.searchOverlay.querySelector('.search-input-wrap'),
      D.searchOverlay.querySelector('.search-hint'),
    ].filter(Boolean) : [];
    let searchTimer;

    function openSearch() {
      if (!D.searchOverlay) return;
      D.searchOverlay.style.display = 'flex';
      D.searchOverlay.classList.add('open');
      if (D.searchInput) D.searchInput.removeAttribute('tabindex');
      gsap.fromTo(D.searchOverlay, { clipPath: 'inset(0 0 100% 0)' }, { clipPath: 'inset(0 0 0% 0)', duration: 0.75, ease: 'expo.out' });
      gsap.fromTo(searchInnerEls, { opacity: 0, y: 12 }, { opacity: 1, y: 0, duration: 0.55, ease: 'power3.out', stagger: 0.07, delay: 0.45, onComplete() { D.searchInput?.focus(); } });
          document.body.classList.add('search-open');

    }
   


    function closeSearch() {
      if (D.searchInput) D.searchInput.setAttribute('tabindex', '-1');
      if (!D.searchOverlay) return;
      gsap.to(searchInnerEls, { opacity: 0, duration: 0.2 });
      gsap.to(D.searchOverlay, { clipPath: 'inset(0 0 100% 0)', duration: 0.55, ease: 'power3.in', delay: 0.1,
        onComplete() {
          D.searchOverlay.classList.remove('open');
          document.body.classList.remove('search-open');

          D.searchOverlay.style.clipPath = '';
          D.searchOverlay.style.display = 'none';
          if (D.searchResults) D.searchResults.innerHTML = '';
          if (D.searchInput)   D.searchInput.value = '';
        },
      });
    }

    D.searchInput && D.searchInput.addEventListener('input', e => {
      clearTimeout(searchTimer);
      const q = e.target.value.trim();
      if (!q || q.length < 2) { if (D.searchResults) D.searchResults.innerHTML = ''; return; }
      searchTimer = setTimeout(() => {
        fetch(`${ROUTES.search}?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title`)
          .then(r => r.json())
          .then(data => _renderSearch(data.resources?.results?.products, q))
          .catch(e => console.error('[Phantasy] search:', e));
      }, 280);
    });

    function _renderSearch(results, query) {
      if (!D.searchResults) return;
      D.searchResults.innerHTML = '';
      const q = (query || '').trim().toLowerCase();
      const filtered = q.length < 2 ? [] : (results || []).filter(item => item.title.toLowerCase().includes(q));
      if (!filtered.length) {
        D.searchResults.innerHTML = `<p style="font-family:'Space Mono',monospace;font-size:8px;letter-spacing:.18em;text-transform:uppercase;color:rgba(232,228,219,.3);margin-top:1em">${STR.noResults}</p>`;
        return;
      }
      filtered.forEach(item => {
        const div = document.createElement('div');
        div.className = 'search-result-item';
        const url = item.featured_image?.url || '';
        div.innerHTML = `${url ? `<img class="search-result-img" src="${url}" alt="${item.title}">` : ''}<span class="search-result-title">${item.title}</span><span class="search-result-price">${formatMoney(item.price)}</span>`;
        div.addEventListener('click', () => {
          const match = PRODUCTS.find(p => p.handle === item.handle);
          closeSearch();
          if (match) {
            goto(S.CAT, { cat: match.cat, filter: CAT_MAP[match.cat] || match.cat });
            setTimeout(() => {
              const pidx = catItems.findIndex(it => it.product.handle === match.handle);
              if (pidx >= 0) catGoTo(pidx);
            }, 350);
          } else {
            window.location.href = `/products/${item.handle}`;
          }
        });
        D.searchResults.appendChild(div);
      });
    }

    window._touchCount = 0;
    window._pinching = false;
    document.addEventListener('touchstart', function(e) {
      window._touchCount = e.touches.length;
      if (window._touchCount > 1) window._pinching = true;
    }, { passive: true });
    document.addEventListener('touchend', function() {
      if (window._touchCount > 1) {
        window._recentPinch = true;
        setTimeout(() => { window._pinching = false; window._recentPinch = false; }, 300);
      }
      window._touchCount = 0;
    }, { passive: true });

    D.searchBtn && D.searchBtn.addEventListener('click', function() { if (window._pinching || window._recentPinch) return; openSearch(); });
    D.searchClose && D.searchClose.addEventListener('click', function() { if (!window._pinching) closeSearch(); });
    D.searchOverlay && D.searchOverlay.addEventListener('click', e => { if (e.target === D.searchOverlay && !window._pinching && !window._touchCount) closeSearch(); });

    /* ═══════════════════════════════════════════════════
       CURRENCY DROPDOWN
    ═══════════════════════════════════════════════════ */
    const currencyItems = D.currencyDrop ? $$('.currency-item') : [];
    let currencyOpen = false;

    function openCurrency() {
      currencyOpen = true;
      D.currencyWrap?.classList.add('open');
      D.currencyDrop && (D.currencyDrop.style.pointerEvents = 'all');
      D.currencyBtn?.setAttribute('aria-expanded', 'true');
      gsap.fromTo(D.currencyDrop, { opacity: 0, y: -14, scale: 0.96 }, { opacity: 1, y: 0, scale: 1, duration: 0.4, ease: 'expo.out' });
      currencyItems.forEach((it, i) => gsap.fromTo(it, { opacity: 0, x: -8 }, { opacity: 1, x: 0, duration: 0.3, ease: 'power2.out', delay: i * 0.03 }));
    }

    function closeCurrency() {
      currencyOpen = false;
      D.currencyWrap?.classList.remove('open');
      D.currencyBtn?.setAttribute('aria-expanded', 'false');
      gsap.to(D.currencyDrop, { opacity: 0, y: -8, scale: 0.97, duration: 0.25, ease: 'power2.in',
        onComplete() { D.currencyDrop && (D.currencyDrop.style.pointerEvents = 'none'); } });
    }

    D.currencyBtn && D.currencyBtn.addEventListener('click', e => { e.stopPropagation(); currencyOpen ? closeCurrency() : openCurrency(); });

    const COUNTRY_CURRENCY = {
      ES:'EUR',DE:'EUR',FR:'EUR',IT:'EUR',PT:'EUR',NL:'EUR',BE:'EUR',
      AT:'EUR',FI:'EUR',GR:'EUR',IE:'EUR',LU:'EUR',SK:'EUR',SI:'EUR',
      US:'USD',CA:'CAD',GB:'GBP',AU:'AUD',JP:'JPY',KR:'KRW',VN:'VND',
      SG:'SGD',TH:'THB',MY:'MYR',CN:'CNY',HK:'HKD',IN:'INR',
    };
    let activeCurrencyCode = 'VND';

   function convertPrices(code) {
  code = 'VND';
  const priceEls = document.querySelectorAll('[data-lock]');
  priceEls.forEach(el => {
    el.textContent = el.dataset.lock;
  });
  document.querySelectorAll('#catInfoPrice, [class*="ai-deck-showcase-price"]').forEach(el => el.style.visibility = 'visible');
}



    function setCurrencyUI(code) {
      activeCurrencyCode = code;
      window.__activeCurrency = code;
      if (D.currencyLabel) D.currencyLabel.textContent = code;
      currencyItems.forEach(el => { el.classList.toggle('active', el.dataset.code === code); });
    }

    setCurrencyUI('VND');
convertPrices('VND');


    currencyItems.forEach(it => it.addEventListener('click', e => {
      e.stopPropagation();
      const code = it.dataset.code;
      setCurrencyUI(code);
     // convertPrices(code);
      setTimeout(closeCurrency, 100);
    }));

    document.addEventListener('click', e => { if (currencyOpen && D.currencyWrap && !D.currencyWrap.contains(e.target)) closeCurrency(); });

    /* ═══════════════════════════════════════════════════
       ENTRY SCREEN
    ═══════════════════════════════════════════════════ */
    const heroMenuItems = D.heroNav ? Array.from(D.heroNav.querySelectorAll('.hero-menu__item')) : [];
    let heroReady = false;

    D.entryScreen && D.entryReceipt && D.entryScreen.addEventListener('mousemove', e => {
      const r = D.entryReceipt.getBoundingClientRect();
      gsap.to(D.entryReceipt, { x: (e.clientX - r.left - r.width / 2) * 0.13, y: (e.clientY - r.top - r.height / 2) * 0.13, duration: 0.55, ease: 'power2.out', overwrite: 'auto' });
    });
    D.entryScreen && D.entryScreen.addEventListener('mouseleave', () => {
      gsap.to(D.entryReceipt, { x: 0, y: 0, duration: 0.9, ease: 'expo.out', overwrite: 'auto' });
    });

    heroMenuItems.forEach(link => {
      link.addEventListener('click', e => {
        e.preventDefault();
        const cat = link.dataset.cat;
        gsap.to(D.heroMenu, { opacity: 0, y: -20, duration: 0.38, ease: 'power2.in',
          onComplete() {
            gsap.set(D.heroMenu, { y: 0 });
            heroHidden = true;
            if (cat === 'Contact') goto(S.CONTACT);
            else goto(S.CAT, { cat, filter: CAT_MAP[cat] || cat });
          },
        });
      });
    });

    heroMenuItems.forEach(item => {
      item.addEventListener('mouseenter', () => {
        if (!heroReady) return;
        heroMenuItems.forEach(o => o !== item && gsap.to(o, { opacity: 0.32, duration: 0.28, ease: 'power2.out', overwrite: 'auto' }));
        gsap.to(item, { opacity: 1, duration: 0.28, ease: 'power2.out' });
      });
      item.addEventListener('mouseleave', () => {
        if (!heroReady) return;
        heroMenuItems.forEach(o => gsap.to(o, { opacity: 1, duration: 0.4, ease: 'power3.out' }));
      });
    });

    D.entryBtn && D.entryBtn.addEventListener('click', () => {
      gsap.to(D.entryScreen, { opacity: 0, duration: 0.65, ease: 'power1.inOut',
        onComplete() {
          D.entryScreen.style.display = 'none';
          reelActive = true;
          gsap.to(D.heroMenu, { opacity: 1, duration: 0.55, ease: 'power2.out' });
          if (D.heroLogoBlock) gsap.fromTo(D.heroLogoBlock, { opacity: 0, y: -14 }, { opacity: 1, y: 0, duration: 0.6, ease: 'expo.out', delay: 0.12 });
          const heroCard = $('heroCard');
          if (heroCard) {
            gsap.fromTo(heroCard, { opacity: 0, y: 50, scale: 0.94 }, { opacity: 1, y: 0, scale: 1, duration: 1.5, ease: 'elastic.out(1,.42)', delay: 0.18 });
            heroCard.addEventListener('mouseenter', () => { heroCard.style.willChange = 'transform'; });
            heroCard.addEventListener('mousemove', e => {
              const r = heroCard.getBoundingClientRect();
              const dx = e.clientX - r.left - r.width / 2, dy = e.clientY - r.top - r.height / 2;
              gsap.to(heroCard, { rotateX: -(dy / r.height) * 2.2, rotateY: (dx / r.width) * 2.2, x: dx * 0.025, y: dy * 0.025 - 6, duration: 0.8, ease: 'power2.out', overwrite: 'auto' });
            });
            heroCard.addEventListener('mouseleave', () => {
              gsap.to(heroCard, { rotateX: 0, rotateY: 0, x: 0, y: 0, duration: 1.1, ease: 'expo.out', overwrite: 'auto', onComplete() { heroCard.style.willChange = ''; } });
            });
          }
          if (heroMenuItems.length) {
            gsap.fromTo(heroMenuItems, { opacity: 0, y: 24 }, { opacity: 1, y: 0, duration: 0.5, ease: 'power3.out', stagger: 0.06, delay: 0.38,
              onComplete() { heroReady = true; heroMenuItems.forEach(it => it.classList.add('ls-animate')); },
            });
          }
          if (N > 0) {
            reelItems.forEach((_, ci) => {
              gsap.to(popStates[ci], { progress: 1, offsetY: 0, duration: 0.75, delay: 0.05 + ci * 0.03, ease: 'back.out(2.5)' });
            });
          }
        },
      });
    });

    /* ═══════════════════════════════════════════════════
       MICRO-INTERACTIONS
    ═══════════════════════════════════════════════════ */
    $$('.nav__hamburger').forEach(el => {
      el.addEventListener('mousedown',  () => gsap.to(el, { scale: 0.88, duration: 0.1, ease: 'power3.in', overwrite: 'auto' }));
      el.addEventListener('mouseup',   () => gsap.to(el, { scale: 1,    duration: 0.4, ease: 'back.out(2)', overwrite: 'auto' }));
      el.addEventListener('mouseleave',() => gsap.set(el, { scale: 1 }));
    });
    $$('.contact-page__field-submit, .bag-checkout-btn').forEach(el => {
      el.addEventListener('mousedown',  () => gsap.to(el, { scale: 0.94, duration: 0.1, ease: 'power3.in', overwrite: 'auto' }));
      el.addEventListener('mouseup',   () => gsap.to(el, { scale: 1,    duration: 0.35, ease: 'back.out(2)', overwrite: 'auto' }));
      el.addEventListener('mouseleave',() => gsap.set(el, { scale: 1 }));
    });
    $$('.bag-continue-btn, .contact-page__back').forEach(el => {
      el.addEventListener('mousedown',  () => gsap.to(el, { scale: 0.95, duration: 0.1, ease: 'power2.in', overwrite: 'auto' }));
      el.addEventListener('mouseup',   () => gsap.to(el, { scale: 1,    duration: 0.45, ease: 'back.out(2)', overwrite: 'auto' }));
      el.addEventListener('mouseleave',() => gsap.set(el, { scale: 1 }));
    });

  } /* end boot() */
})();
